<template>
  <div class="procurement-detail">
    <GlobalHeader />

    <div class="main-container">
      <!-- Breadcrumb -->
      <div class="breadcrumb">您当前的位置：招标信息>文章详情</div>

      <!-- Title -->
      <h1 class="page-title">{{ detail.title || "--" }}</h1>

      <!-- Info bar -->
      <div class="info-container">
        <div class="info-bar" v-if="detail.projectInfo">
          <div class="info-item">
            项目编号：{{ detail.projectInfo.projectCode || "--" }}
          </div>
          <div class="info-item">
            采购方式：{{ detail.projectInfo.tenderMethodName || "--" }}
          </div>
          <!-- <div class="info-item">
            报名截止时间：{{
              detail.projectInfo.registrationDeadline
                ? $moment(detail.projectInfo.registrationDeadline).format(
                  "YYYY-MM-DD HH:mm"
                )
                : "--"
            }}
          </div> -->
        </div>
        <div class="date">
          {{
            detail.createdDate
              ? $moment(detail.createdDate).format("YYYY-MM-DD HH:mm")
              : "--"
          }}
        </div>
      </div>
      <!-- Divider -->
      <div class="divider"></div>
      <!-- Content -->
      <div class="content" v-html="detail.context"></div>
      <!-- 供应商角色-报名 -->
      <div class="supplier-role-container"
        v-if="$store.getters.role === 'Supplier' || $store.getters.role === 'SupplierSubAccount'">
        <!-- 1=可以报名,2=已过截止时间,3=已报名 4同组其他人已报名，当前用户不能报名-->
        <a-button size="large" type="primary" class="action-btn" :loading="loading" @click="handleSubmit"
          v-if="isCanRegiste == 1">项目报名</a-button>
        <!-- <a-button size="large" disabled v-else-if="isCanRegiste == 2">已过截止时间</a-button>-->
        <a-button size="large" disabled v-else-if="isCanRegiste == 3">已报名</a-button>
        <a-button size="large" disabled v-else-if="isCanRegiste == 4">同组其他人已报名</a-button> 
        <span v-else></span>
      </div>
      <!-- 报名弹框 -->
      <SignupModal v-if="hasProjectId" :visible.sync="modalVisible" :projectId="signupProjectId"
        :projectCode="detail.projectInfo && detail.projectInfo.projectCode" :userInfo="userInfo"
        @success="handleSuccess" />
    </div>
  </div>
</template>

<script>
import GlobalHeader from "@/components/GlobalHeader.vue";
import { getProjectNoticeDetail } from "@/api/common";
import { getSupplierCanRegister } from "@/api/supplier";
import SignupModal from "./components/SignupModal.vue";

export default {
  name: "ProcurementDetail",
  components: {
    GlobalHeader,
    SignupModal,
  },
  data() {
    return {
      id: this.$route.query.id || null,
      detail: {
        projectInfo: {},
      },
      loading: false,
      isCanRegiste: false,
      modalVisible: false,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo || {};
    },
    hasProjectId() {
      return this.detail.projectInfo && this.detail.projectInfo.id !== undefined && this.detail.projectInfo.id !== null;
    },
    signupProjectId() {
      return this.hasProjectId ? String(this.detail.projectInfo.id) : "";
    },
  },
  async created() {
    if (this.id) {
      await this.fetchData();
      // 供应商角色调用接口
      if (this.$store.getters.role === "Supplier" || this.$store.getters.role === "SupplierSubAccount") {
        await this.getSupplierCanRegisterFun();
      }
    }
  },
  methods: {
    fetchData() {
      this.loading = true;
      return getProjectNoticeDetail({ id: this.id })
        .then((res) => {
          if (res) {
            this.detail = res;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSupplierCanRegisterFun() {
      if (!this.detail.projectInfo || !this.detail.projectInfo.id) return;
      return getSupplierCanRegister({ id: this.detail.projectInfo.id }).then((res) => {
        this.isCanRegiste = res;
      });
    },
    handleSubmit() {
      if (!this.isCanRegiste) return;
      this.modalVisible = true;
    },
    handleSuccess() {
      this.isCanRegiste = false;
      // 跳转到报名成功页面
      this.$router.push({
        path: "/supplier-center/project-management",
      });
    }
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/variables.less";

.procurement-detail {
  width: 100%;
  min-height: 100vh;
  background-color: #fafafc;
  font-family: "PingFang SC", sans-serif;
  padding-bottom: 90px;
  box-sizing: border-box;
}

.main-container {
  width: 1200px;
  margin: 0 auto;
  padding: 0 28px 34px 28px;
  background-color: #fff;
}

.breadcrumb {
  padding: 24px 0 0 0;
  font-size: 14px;
  color: #000000;
  line-height: 1.5;
}

.page-title {
  text-align: center;
  padding: 24px 0 0 0;
  font-size: 20px;
  color: #5772c3;
  margin: 0;
  line-height: 1.5;
  font-weight: bold;
}

.info-container {
  display: flex;
  margin-top: 13px;
  justify-content: space-between;
  color: #606472;
}

.info-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 48px;
}

.info-item {
  font-size: 14px;
  color: #606472;
  line-height: 1.5;
}

.date {
  // text-align: right;
  // font-size: 15px;
  // color: #000000;
  // margin-top: 15px;
  // padding-right: 60px;
}

.divider {
  height: 1px;
  background-color: #dbdce7;
  margin: 15px 0 30px;
}

.content {
  font-size: 17px;
  color: #000000;
  line-height: 1.5;
  font-weight: 400;
  margin-bottom: 50px;
}

.content p {
  margin: 0 0 1em 0;
  text-align: justify;
}

.action-btn {
  width: 100px;
  background-color: #5772C3;
  border-color: #5772C3;

  &:hover {
    background-color: #4a61a8;
    border-color: #4a61a8;
  }
}

.supplier-role-container {
  text-align: center;

  /deep/button {
    width: 400px;
    height: 54px;
  }
}
</style>
